import { Option } from "api/types/_public";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownOptionApp from "components/Common/DropdownOptionApp";
import LabelWrapper from "components/Common/LabelWrapper";
import TableContainer from "components/Common/TableContainer";
import { useRole } from "components/Hooks/UserHooks";
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { APP_TYPE_OPTIONS } from "helpers/constans";
import { formatNumberWithCommas } from "helpers/format";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import { getRegionalCityStatistics as onGetStatistics } from "../../../store/thunks";


const SORT_BY_DEFAULT = 'installs';
const ORDER_BY_DEFAULT = 'DESC';

registerLocale('en', en);
registerLocale('ko', ko);

const Statistic = () => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();
    const navigate = useNavigate();

    const APP_TYPE_OPTIONS_LANG = APP_TYPE_OPTIONS?.map(
        (item: any) => ({ value: item?.value, label: t(item?.label) })
    );

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 100),
        sort_by: withDefault(StringParam, SORT_BY_DEFAULT),
        order_by: withDefault(StringParam, ORDER_BY_DEFAULT),
        start_date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
        end_date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
        app_type: withDefault(StringParam, `${APP_TYPE_OPTIONS_LANG[0]?.value}`),
        type: withDefault(StringParam, 'province'),
    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Statistic;

    const ReportProperties = createSelector(
        selectLayoutState,
        (state) => ({
            statistics: state.regionalCityStatistics,
            isStatisticSuccess: state.isRegionalCityStatisticSuccess,
            isStatisticLoading: state.isRegionalCityStatisticLoading,
            error: state.error,
        })
    );

    const { statistics, isStatisticLoading } = useSelector(ReportProperties);

    const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateSearch;

    const [appTypeSearch, setAppTypeSearch] = useState<Option | null>(APP_TYPE_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.app_type)) || null);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [listCountry, setListCountry] = useState<any>([]);

    useEffect(() => {
        dispatch(onGetStatistics(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        setQuery({
            ...query,
            page: 1,
            start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
            end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
            app_type: appTypeSearch?.value || '',
            time_request: + new Date()
        });
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            start_date: `${moment().format("Y-MM-DD")}`,
            end_date: `${moment().format("Y-MM-DD")}`,
            app_type: `${APP_TYPE_OPTIONS_LANG[0]?.value}`,
            sort_by: SORT_BY_DEFAULT,
            order_by: ORDER_BY_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setAppTypeSearch(APP_TYPE_OPTIONS_LANG[0]);
        setDateSearch([moment(queryNew?.start_date || "", 'Y-MM-DD').toDate(), moment(queryNew?.end_date || "", 'Y-MM-DD').toDate()]);
    };

    // Column
    const columns = useMemo(
        () => [
            // {
            //     Header: t('Date'),
            //     accessor: "date",
            //     filterable: true,
            //     sortable: true,
            //     thWidth: 150,
            //     thClass: 'align-middle text-start',
            //     Cell: (cell: any) => {
            //         return <></>
            //     },
            // },
            {
                Header: t('No.'),
                accessor: "rank",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-start',
                thWidth: 100,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div className="text-start pe-3 " style={{ minWidth: '60px' }}>{!!item?.text_row ? '' : (cell?.cell?.row?.index)}</div>
                        </>
                    )
                },
            },
            {
                Header: t('Region'),
                accessor: "region",
                filterable: false,
                sortable: false,
                thClass: 'align-middle text-start',
                thWidth: 140,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div
                                className="pe-3 d-flex justify-content-start"
                            >
                                {!!item?.text_row ? <>{item?.text_row}</> : <>{
                                    <div className="d-flex gap-2 align-items-center justify-content-end" >
                                        <div className="cursor-pointer text-start" style={{ width: "130px" }}>
                                            {cell?.value}
                                        </div>
                                    </div>}</>}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t('Installs'),
                accessor: "installs",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: 200,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-end pe-3">{formatNumberWithCommas(cell?.value || 0)}</div>
                    )
                },
            },
            {
                Header: t('Sign-ups'),
                accessor: "sign_ups",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: 140,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-end pe-3">{formatNumberWithCommas(cell?.value || 0)}</div>
                    )
                },
            },
            {
                Header: t('Sign-up Rate'),
                accessor: "sign_ups_rate",
                filterable: true,
                sortable: true,
                thClass: 'align-middle text-end',
                thWidth: 160,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div className="text-end pe-3" style={{ minWidth: '120px' }}>{formatNumberWithCommas(cell?.value || 0)} %</div>
                        </>
                    )
                },
            },
        ],
        [i18n?.language, userPermissions]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleChangePicker = (values: any[] = []) => {
        setDateSearch((_prev: any) => values);
    }

    useEffect(() => {
        const handleCallAllOption = async () => {
            // try {
            //     const [resCountry]: any = await Promise.all([
            //         countryApi.countries({ page: 1, limit: 20000 }),
            //     ]);
            //     setListCountry((_prev: any) => resCountry?.data || []);
            // } catch (error: any) {
            //     return error;
            // }
        };

        handleCallAllOption();
    }, []);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    const categories = useMemo(() => {
        return statistics?.items?.map((item: any) => item?.date).reverse() || [];
    }, [statistics?.items, i18n?.language]);

    const series = useMemo(() => {
        const obChart = statistics?.items?.reduce((ob: any, item: any) => {
            ob.click?.push(Number(String(item?.total_click).replace(/,/g, '')));
            ob.install?.push(Number(String(item?.total_install).replace(/,/g, '')));
            ob.conversion_rate?.push(Number(String(item?.conversion_rate).replace(/,/g, '')));
            return ob;
        }, { click: [], install: [] }) || [];
        return (
            [
                {
                    name: t('Clicks'),
                    type: 'column',
                    data: obChart?.click?.reverse(),
                },
                {
                    name: t('Installs'),
                    type: 'line',
                    data: obChart?.install?.reverse(),
                },
                {
                    name: t('Conversion Rate'),
                    type: 'line',
                    data: obChart?.conversion_rate?.reverse(),
                },
            ]
        )
    }, [statistics?.items, i18n?.language]);


    useEffect(() => {
        document.title = `${t("Regional Statistics (City)")} - ${t("Home")}`;
        document.body.classList.remove("vertical-sidebar-enable");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t('Regional Statistics (City)')} pageTitle={t('Home')} />
                    <Row>
                        <Col sm={12} md={12}>
                            <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }} className="ribbon-box right">
                                <div className="ribbon round-shape" style={{ background: 'rgb(40 99 213)', fontWeight: 300, fontSize: '0.8rem', top: '11px' }}>{t('This data is analyzed per 10 mins')}</div>
                                <CardHeader className="border-0" style={{ borderRadius: '30px' }}>
                                    <Row className="g-4 align-items-center">
                                        <div className="col-sm">
                                            <div>
                                                <h5 className="card-title mb-0">
                                                    <span className="me-2">{t('Total')}:</span>
                                                    <CountUp
                                                        start={0}
                                                        end={statistics?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />
                                                </h5>
                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                    <Row className="g-4 align-items-center mt-0">
                                        <Col sm={6} md={3} xl={3} xxl={3} className='mt-3 mt-md-2'>
                                            <LabelWrapper label={t('App')} isShow={true}>
                                                <DropdownOptionApp
                                                    name=""
                                                    dataList={APP_TYPE_OPTIONS_LANG}
                                                    placeholder={`${t("App")}...`}
                                                    className="search-filter-category-type dropdown-status-rounded"
                                                    classNamePrefix="name-prefix"
                                                    initialValue={appTypeSearch || null}
                                                    onChangeSelect={(e: any) => setAppTypeSearch(e)}
                                                    isHasOptionAll={true}
                                                    optionAll={{ label: t('All'), value: '' }}
                                                />
                                            </LabelWrapper>
                                        </Col>
                                        <Col sm={6} md={3} xl={3} xxl={3} className='date-picker-wrapper-custom mt-3 mt-md-2'>
                                            <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                                <DatePickerCustom
                                                    placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                    startDate={startDate || null}
                                                    endDate={endDate || null}
                                                    onChangePicker={handleChangePicker}
                                                    showOptions={[
                                                        'today',
                                                        'yesterday', 'two_day_ago',
                                                        'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                        'this_week', 'last_week',
                                                        'this_month', 'last_month',
                                                    ]}
                                                    maxDate={new Date(new Date().setDate(new Date().getDate()))}
                                                />
                                            </LabelWrapper>
                                        </Col>
                                        <Col sm={12} md={6} xl={6} xxl={6} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-md-start mt-3 mt-md-2">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary me-2 "
                                                    onClick={searchData}
                                                    disabled={(isStatisticLoading)}
                                                >
                                                    {t('Button Search')}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary fs-14"
                                                    disabled={isLoading}
                                                    onClick={resetData}
                                                >
                                                    <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                    {t('Button Reset')}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                {/* <ChartLine
                                    className="my-3"
                                    titles={[t('Clicks'), t('Installs'), t('Conversion Rate')]}
                                    categories={categories}
                                    series={series}
                                /> */}
                                <CardBody className="pt-3">
                                    <TableContainer
                                        className="custom-header-css"
                                        divClass="table-responsive table-card"
                                        tableClass="align-middle table-bordered-dashed table-have-first-row-is-total sticky-table-regional-statistics"
                                        theadClass="table-light text-muted"
                                        columns={columns}
                                        data={
                                            statistics?.items?.length
                                                ? [
                                                    {
                                                        ...statistics?.total_data,
                                                        text_row: t("Sum"),
                                                    },
                                                    ...statistics?.items,
                                                ]
                                                : []
                                        }
                                        customPageSize={query.limit}
                                        customPageIndex={query.page - 1}
                                        totalRecords={statistics?.pagination?.total}
                                        customPageCount={Math.ceil(Number(statistics?.pagination?.total) / Number(statistics?.pagination?.limit))}
                                        handleChangePage={handleChangePage}
                                        manualSorting={true}
                                        sorting={{
                                            sort_by: query.sort_by,
                                            order_by: query.order_by,
                                        }}
                                        handleChangeSorting={handleChangeSorting}
                                        isLoading={isStatisticLoading}
                                        isShowPagination={false}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <ToastContainer closeButton={false} limit={1} />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Statistic;
